import { fetchImpulseData, fetchImpulseCoinsList, fetchCompareImpulses } from "@/Groups/Scanner/private/api/impulseData";

const state = () => ({
  impulses: [],
  compareImpulses: [],
  isReady: false,
  isOpened: true,
  isLoading: false,
  idActiveImpulse: null,
});

const actions = {
  async updateImpulseList({ state, commit }, { custom_tag_id, base_coin_id, tag_id, usd }){
    try{
      let params = {};
      if(base_coin_id) params['base_coin_id'] = base_coin_id;
      if(usd) params['usd'] = usd;
      if(custom_tag_id) params['custom_tag_id'];
      if(tag_id) params['tag_id'] = tag_id;
      commit('SET_LOADING_FLAG', true);
      const data = await fetchImpulseData(params);
      commit('SET_READY_FLAG', true);
      commit('SET_DATA', data);
      console.log(data)
      return data;
    } catch(err){
      console.warn('Ошибка', err)
    } finally{
      commit('SET_LOADING_FLAG', false);
    }
  },

  async loadCoinsList({ state, commit }, params){
    try{
      commit('SET_ACTIVE_IMPULSE_ID', params.impulse_id);
      return await fetchImpulseCoinsList(params);
    } catch(err){
      console.warn('Ошибка', err)
    } finally{
      commit('SET_LOADING_FLAG', false);
    }
  },

  async loadCompare({ commit }, params) {
    try {
      commit('SET_LOADING_FLAG', true);
      const data = await fetchCompareImpulses(params);
      commit('SET_COMPARE_IMPULSES', data);
      return data;
    } catch (err) {
      console.warn('Ошибка при загрузке сравнения импульсов:', err);
    } finally {
      commit('SET_LOADING_FLAG', false);
    }
  },

  async resetCompare({ commit }) {
    commit('SET_COMPARE_IMPULSES', null);
  },

  toggleOpended({ state, commit }){
    const status = (state.isOpened) ? false : true;
    commit('SET_OPENED_LIST_FLAG', status);
  },

  setActiveImpulseId({ commit }, id) {
    commit('SET_ACTIVE_IMPULSE_ID', id);
  },

  resetImpulse({ commit }) {
    commit('SET_DATA', []);
    commit('SET_COMPARE_IMPULSES', []);
    commit('SET_READY_FLAG', false);
    commit('SET_LOADING_FLAG', false);
    commit('SET_OPENED_LIST_FLAG', true);
    commit('SET_ACTIVE_IMPULSE_ID', null);
  },
};

const mutations = {
  SET_DATA(state, data){ state.impulses = data },

  SET_COMPARE_IMPULSES(state, data) { state.compareImpulses = data; },

  SET_READY_FLAG(state, status = true){ state.isReady = status },

  SET_LOADING_FLAG(state, status){ state.isLoading = status },

  SET_OPENED_LIST_FLAG(state, status){ state.isOpened = status },

  SET_ACTIVE_IMPULSE_ID(state, id){ state.idActiveImpulse = id; }
};

const getters = {
  //Получить все импульсы
  allImpulses: (state) => state.impulses,
  //Готовы ли импульсы к отображению
  isImpulseReady: (state) => state.isReady,
  //Идет ли загрузка импульсов
  isImpulseLoading: (state) => state.isLoading,
  //Получить элемент импульса по ID
  getImpulseById: (state) => (id) => state.impulses.find(item => item.id === id) || null,
  //Кол-во импульсов
  impulsesCount: (state) => state.impulses.length,
  //Развернут ли список импульсов
  isOpenedList: (state) => state.isOpened,
  //Получить активный ID импульса
  activeImpulseId: (state) => state.idActiveImpulse,
  //Получить список compare impulse
  getCompareImpulses: (state) => state.compareImpulses,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

const compare = [
    {
        "impulse_name": "Рост с макро дна",
        "start_date": "2025-04-09T10:10:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": false,
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "price_start": "76914.80199383130000",
            "price_end": "109293.47356903930000",
            "change_percent": 42.1
        },
        "compare_coin": {
            "id": 49881,
            "name": "Pudgy Penguins",
            "symbol": "PENGU",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/pudgy-penguins_36x36.webp",
            "price_start": "0.00399087000000",
            "price_end": "0.02700359000000",
            "change_percent": 576.63
        },
        "change_percent": 576.63,
        "relative_percent": 534.53
    },
    {
        "impulse_name": "Падение с макро хая",
        "start_date": "2025-08-14T03:30:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": false,
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "price_start": "123743.92897565896000",
            "price_end": "109293.47356903930000",
            "change_percent": -11.68
        },
        "compare_coin": {
            "id": 49881,
            "name": "Pudgy Penguins",
            "symbol": "PENGU",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/pudgy-penguins_36x36.webp",
            "price_start": "0.03756924000000",
            "price_end": "0.02700359000000",
            "change_percent": -28.12
        },
        "change_percent": -28.12,
        "relative_percent": -16.44
    },
    {
        "impulse_name": "Рост с локального дна",
        "start_date": "2025-06-23T02:15:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": false,
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "price_start": "100828.61102745130000",
            "price_end": "109293.47356903930000",
            "change_percent": 8.4
        },
        "compare_coin": {
            "id": 49881,
            "name": "Pudgy Penguins",
            "symbol": "PENGU",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/pudgy-penguins_36x36.webp",
            "price_start": "0.00833488000000",
            "price_end": "0.02700359000000",
            "change_percent": 223.98
        },
        "change_percent": 223.98,
        "relative_percent": 215.58
    },
    {
        "impulse_name": "Падение с локального хая",
        "start_date": "2025-08-14T03:30:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": false,
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "price_start": "123743.92897565896000",
            "price_end": "109293.47356903930000",
            "change_percent": -11.68
        },
        "compare_coin": {
            "id": 49881,
            "name": "Pudgy Penguins",
            "symbol": "PENGU",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/pudgy-penguins_36x36.webp",
            "price_start": "0.03756924000000",
            "price_end": "0.02700359000000",
            "change_percent": -28.12
        },
        "change_percent": -28.12,
        "relative_percent": -16.44
    },
    {
        "impulse_name": "Отскок с 23 сент.",
        "start_date": "2025-09-23T03:00:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": true,
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "price_start": "112656.19698186153000",
            "price_end": "109293.47356903930000",
            "change_percent": -2.98
        },
        "compare_coin": {
            "id": 49881,
            "name": "Pudgy Penguins",
            "symbol": "PENGU",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/pudgy-penguins_36x36.webp",
            "price_start": "0.03091251000000",
            "price_end": "0.02700359000000",
            "change_percent": -12.65
        },
        "change_percent": -12.65,
        "relative_percent": -9.67
    },
    {
        "impulse_name": "Коррекция с 18 сент.",
        "start_date": "2025-09-18T03:00:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": true,
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "price_start": "116236.81072905796000",
            "price_end": "109293.47356903930000",
            "change_percent": -5.97
        },
        "compare_coin": {
            "id": 49881,
            "name": "Pudgy Penguins",
            "symbol": "PENGU",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/pudgy-penguins_36x36.webp",
            "price_start": "0.03593089000000",
            "price_end": "0.02700359000000",
            "change_percent": -24.85
        },
        "change_percent": -24.85,
        "relative_percent": -18.88
    },
    {
        "impulse_name": "Локальное дно – хай",
        "start_date": "2025-06-22T22:00:00+03:00",
        "end_date": "2025-08-14T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": false,
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "price_start": "99647.80711323743000",
            "price_end": "123743.92897565896000",
            "change_percent": 24.18
        },
        "compare_coin": {
            "id": 49881,
            "name": "Pudgy Penguins",
            "symbol": "PENGU",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/pudgy-penguins_36x36.webp",
            "price_start": "0.00800866000000",
            "price_end": "0.03756924000000",
            "change_percent": 369.11
        },
        "change_percent": 369.11,
        "relative_percent": 344.93
    },
    {
        "impulse_name": "Трамп-ралли",
        "start_date": "2024-11-05T03:15:00+03:00",
        "end_date": "2025-01-20T10:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": false,
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "price_start": "67887.00000000000000",
            "price_end": "107242.15675513133000",
            "change_percent": 57.97
        },
        "compare_coin": {
            "id": 49881,
            "name": "Pudgy Penguins",
            "symbol": "PENGU",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/pudgy-penguins_36x36.webp",
            "price_start": "0.02926843000000",
            "price_end": "0.02605568000000",
            "change_percent": -10.98
        },
        "change_percent": -10.98,
        "relative_percent": -68.95
    },
    {
        "impulse_name": "Весь 2025 год",
        "start_date": "2025-01-01T03:00:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": true,
        "in_dynamic_list": false,
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "price_start": "93490.94830605846000",
            "price_end": "109293.47356903930000",
            "change_percent": 16.9
        },
        "compare_coin": {
            "id": 49881,
            "name": "Pudgy Penguins",
            "symbol": "PENGU",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/pudgy-penguins_36x36.webp",
            "price_start": "0.03299785000000",
            "price_end": "0.02700359000000",
            "change_percent": -18.17
        },
        "change_percent": -18.17,
        "relative_percent": -35.07
    },
    {
        "impulse_name": "Весь 2024 год",
        "start_date": "2024-01-01T03:00:00+03:00",
        "end_date": "2025-01-01T03:00:00+03:00",
        "is_year": true,
        "in_dynamic_list": false,
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "price_start": "42737.17674522968000",
            "price_end": "93490.94830605846000",
            "change_percent": 118.76
        },
        "compare_coin": {
            "id": 49881,
            "name": "Pudgy Penguins",
            "symbol": "PENGU",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/pudgy-penguins_36x36.webp",
            "price_start": "0.02926843000000",
            "price_end": "0.03299785000000",
            "change_percent": 12.74
        },
        "change_percent": 12.74,
        "relative_percent": -106.02
    }
]

const dataTest = [
    {
        "impulse_id": 1,
        "impulse_name": "Рост с макро дна",
        "description": "Восстановление рынков благодаря паузе тарифов США, а также пакет позитивных регуляторных мер и рост институционального интереса — включая GENIUS Act и другие законы.",
        "start_date": "2025-04-09T10:10:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": false,
        "trend_type": "global_low",
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "dropstab_url": "https://dropstab.com/coins/bitcoin",
            "price_start": "76914.80199383129366",
            "price_end": "109293.47356903930000",
            "mcap_start": "1526658061186.939500",
            "mcap_end": "2177803940911.811500",
            "change_percent": 42.1
        },
        "coins": []
    },
    {
        "impulse_id": 2,
        "impulse_name": "Падение с макро хая",
        "description": "Заявление США о прекращении закупок криптовалют и данные по инфляции (PPI), пошатнувшие надежды на снижение ставок ФРС, спровоцировали падение рынка.",
        "start_date": "2025-08-14T03:30:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": false,
        "trend_type": "global_high",
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "dropstab_url": "https://dropstab.com/coins/bitcoin",
            "price_start": "123743.92897565896000",
            "price_end": "109293.47356903930000",
            "mcap_start": "2463242690383.739700",
            "mcap_end": "2177803940911.811500",
            "change_percent": -11.68
        },
        "coins": []
    },
    {
        "impulse_id": 3,
        "impulse_name": "Рост с локального дна",
        "description": "Рост на фоне укрепления институционального доверия, принятия GENIUS Act и разрешения банкам легально хранить криптоактивы.",
        "start_date": "2025-06-23T02:15:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": false,
        "trend_type": "local_low",
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "dropstab_url": "https://dropstab.com/coins/bitcoin",
            "price_start": "100828.61102745130484",
            "price_end": "109293.47356903930000",
            "mcap_start": "2004707818718.036600",
            "mcap_end": "2177803940911.811500",
            "change_percent": 8.4
        },
        "coins": []
    },
    {
        "impulse_id": 4,
        "impulse_name": "Падение с локального хая",
        "description": "Заявление США о прекращении закупок криптовалют и данные по инфляции (PPI), пошатнувшие надежды на снижение ставок ФРС, спровоцировали падение рынка.",
        "start_date": "2025-08-14T03:30:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": false,
        "trend_type": "local_high",
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "dropstab_url": "https://dropstab.com/coins/bitcoin",
            "price_start": "123743.92897565896000",
            "price_end": "109293.47356903930000",
            "mcap_start": "2463242690383.739700",
            "mcap_end": "2177803940911.811500",
            "change_percent": -11.68
        },
        "coins": []
    },
    {
        "impulse_id": 9,
        "impulse_name": "Отскок с 23 сент.",
        "description": "",
        "start_date": "2025-09-23T03:00:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": true,
        "trend_type": "",
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "dropstab_url": "https://dropstab.com/coins/bitcoin",
            "price_start": "112656.19698186153255",
            "price_end": "109293.47356903930000",
            "mcap_start": "2244482758703.934000",
            "mcap_end": "2177803940911.811500",
            "change_percent": -2.98
        },
        "coins": []
    },
    {
        "impulse_id": 10,
        "impulse_name": "Коррекция с 18 сент.",
        "description": "",
        "start_date": "2025-09-18T03:00:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": true,
        "trend_type": "",
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "dropstab_url": "https://dropstab.com/coins/bitcoin",
            "price_start": "116236.81072905796000",
            "price_end": "109293.47356903930000",
            "mcap_start": "2315711472359.344700",
            "mcap_end": "2177803940911.811500",
            "change_percent": -5.97
        },
        "coins": []
    },
    {
        "impulse_id": 8,
        "impulse_name": "Локальное дно – хай",
        "description": "Рост биткоина произошел благодаря рекордным притокам в ETF, институциональному спросу и политической поддержке в США.",
        "start_date": "2025-06-22T22:00:00+03:00",
        "end_date": "2025-08-14T03:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": false,
        "trend_type": "",
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "dropstab_url": "https://dropstab.com/coins/bitcoin",
            "price_start": "99647.80711323743162",
            "price_end": "123743.92897565896000",
            "mcap_start": "1981222911920.586200",
            "mcap_end": "2463242690383.739700",
            "change_percent": 24.18
        },
        "coins": []
    },
    {
        "impulse_id": 7,
        "impulse_name": "Трамп-ралли",
        "description": "Рост крипторынка был вызван победой Трампа, его обещаниями стратегического биткоин-резерва и мягкого регулирования, а также мемкойн-бумом и ожиданиями институционального спроса.",
        "start_date": "2024-11-05T03:15:00+03:00",
        "end_date": "2025-01-20T10:00:00+03:00",
        "is_year": false,
        "in_dynamic_list": false,
        "trend_type": "",
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "dropstab_url": "https://dropstab.com/coins/bitcoin",
            "price_start": "67887.00000000000000",
            "price_end": "107242.15675513133465",
            "mcap_start": "1342656323244.000000",
            "mcap_end": "2124742201451.229000",
            "change_percent": 57.97
        },
        "coins": []
    },
    {
        "impulse_id": 5,
        "impulse_name": "Весь 2025 год",
        "description": "",
        "start_date": "2025-01-01T03:00:00+03:00",
        "end_date": "2025-09-26T03:00:00+03:00",
        "is_year": true,
        "in_dynamic_list": false,
        "trend_type": "",
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "dropstab_url": "https://dropstab.com/coins/bitcoin",
            "price_start": "93490.94830605846000",
            "price_end": "109293.47356903930000",
            "mcap_start": "1851487354468.265600",
            "mcap_end": "2177803940911.811500",
            "change_percent": 16.9
        },
        "coins": []
    },
    {
        "impulse_id": 6,
        "impulse_name": "Весь 2024 год",
        "description": "",
        "start_date": "2024-01-01T03:00:00+03:00",
        "end_date": "2025-01-01T03:00:00+03:00",
        "is_year": true,
        "in_dynamic_list": false,
        "trend_type": "",
        "base_coin": {
            "id": 1,
            "name": "Bitcoin",
            "symbol": "BTC",
            "image": "https://dropscapital.fra1.digitaloceanspaces.com/media/coin_images/bitcoin_36x36.webp",
            "dropstab_url": "https://dropstab.com/coins/bitcoin",
            "price_start": "42737.17674522968000",
            "price_end": "93490.94830605846000",
            "mcap_start": "837055685879.161600",
            "mcap_end": "1851487354468.265600",
            "change_percent": 118.76
        },
        "coins": []
    }
]